import { Instagram, Facebook } from "lucide-react";

const PHOTOS = [
  "https://forestgreen-dugong-952582.hostingersite.com/wp-content/uploads/2026/05/IMG_2684-2-683x1024.jpeg",
  "https://forestgreen-dugong-952582.hostingersite.com/wp-content/uploads/2026/05/IMG_2683-5-683x1024.jpeg",
  "https://forestgreen-dugong-952582.hostingersite.com/wp-content/uploads/2026/05/IMG_2685-2-683x1024.jpeg",
];

export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Tag */}
        <div className="mb-16 text-center">
          <span className="text-[#E4077B] text-xs tracking-[0.25em] uppercase font-medium">Conheça</span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Amine Cudo
          </h2>
          <div className="w-12 h-0.5 bg-[#E4077B] mx-auto mt-4" />
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Text Content */}
          <div className="space-y-6 order-2 lg:order-1">
            <p className="text-[#555555] leading-relaxed text-base">
              <span className="text-[#E4077B] font-medium text-lg">A</span>ntes de montar mesas, eu montava planos de aula. Mas foi nas festas que encontrei minha verdadeira vocação.
            </p>
            <p className="text-[#555555] leading-relaxed text-base">
              Por muitos anos, fui professora. Sempre gostei de cuidar dos detalhes, organizar momentos especiais. Mas toda vez que alguém da família fazia aniversário... lá estava eu: planejando cada cor, pensando nos balões, escolhendo os detalhes da mesa. Era ali que meu coração queimava.
            </p>
            <blockquote className="border-l-2 border-[#E4077B] pl-6 py-2 my-8">
              <p className="text-[#1a1a1a] italic text-lg font-light" style={{ fontFamily: "Outfit, sans-serif" }}>
                "E será que esse é meu dom? E se for isso que eu realmente amo fazer?"
              </p>
            </blockquote>
            <p className="text-[#555555] leading-relaxed text-base">
              Hoje, a Amine Festas é o reflexo dessa escolha. Cada projeto que entrego carrega um pedacinho da minha história: o cuidado de professora, o olhar atento aos detalhes e a paixão de quem finalmente se encontrou.
            </p>
            <p className="text-[#555555] leading-relaxed text-base">
              Transformar festas em memórias afetivas não é só um trabalho. É a realização de quem teve coragem de seguir o que ama.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4 pt-6">
              <span className="text-xs tracking-[0.2em] uppercase text-[#555555]">Siga Amine</span>
              <a
                href="https://www.instagram.com/aminefestas"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-instagram-link"
                className="w-10 h-10 rounded-full bg-[#E4DCCC]/50 flex items-center justify-center text-[#1a1a1a] hover:bg-[#E4077B] hover:text-white transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61557509742561"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-facebook-link"
                className="w-10 h-10 rounded-full bg-[#E4DCCC]/50 flex items-center justify-center text-[#1a1a1a] hover:bg-[#E4077B] hover:text-white transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Photos Grid */}
          <div className="order-1 lg:order-2 grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <img
                src={PHOTOS[0]}
                alt="Amine Cudo"
                className="w-full h-80 object-cover object-top rounded-3xl"
                data-testid="about-photo-1"
              />
            </div>
            <img
              src={PHOTOS[1]}
              alt="Amine Cudo"
              className="w-full h-64 object-cover object-top rounded-3xl"
              data-testid="about-photo-2"
            />
            <img
              src={PHOTOS[2]}
              alt="Amine Cudo"
              className="w-full h-64 object-cover object-top rounded-3xl"
              data-testid="about-photo-3"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
